module.exports = __webpack_public_path__ + "static/media/micah.afc3902e.png";